import React, { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { defaultTabs } from "../../../consts/tabs";
import { COLLECTION_TYPE_CHANGE_ON_EDIT_WARNING } from "../../../consts/strings";
import { COLLECTIONS_PLAN_TYPE } from "../../../consts/planTypes";

import { addNotification, setSelectedTab } from "../../../reducers/ownApp";
import {
  getMatrixProfileType,
  isEditOneModeSelector,
} from "../../../reducers/matrixProfile/selectors";
import { selectedTabSelector } from "../../../reducers/ownApp/selectors";

import { useLocationDetails } from "../../../hooks/useLocationDetails";

import HeaderTabs from "./HeaderTabs";
import { SectionMenuProvider } from "./useSectionMenuContext";

const useStyles = makeStyles(() => ({
  sectionMenu: {
    width: (props) => {
      if (props.isDriverManagement && props.activeTabIndex === 1)
        return "23rem";
      else return "19.625rem";
    },
    background: "#303030",
    top: 0,
    left: 0,
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  listsContainer: {
    display: "flex",
    flexDirection: "column",
    background: "#303030",
    height: "calc(100% - 48px)",
  },
}));

export const SectionMenu = memo(
  ({ tabs = defaultTabs, activeTab = 1, children }) => {
    const selectedTab = useSelector(selectedTabSelector);
    const isEditOneMode = useSelector(isEditOneModeSelector);
    const type = useSelector(getMatrixProfileType);
    const dispatch = useDispatch();
    const [activeTabIndex, setActiveTabIndex] = useState(activeTab);
    const disabled = type === COLLECTIONS_PLAN_TYPE && isEditOneMode;
    const { isDriverManagement } = useLocationDetails();
    const styles = useStyles({ isDriverManagement, activeTabIndex });

    useEffect(() => {
      if (tabs[activeTabIndex])
        dispatch(setSelectedTab(tabs[activeTabIndex].label));
      else dispatch(setSelectedTab(tabs[0].label));
    }, [activeTabIndex, dispatch, tabs]);

    useEffect(() => {
      if (
        tabs[activeTabIndex]?.label !== selectedTab &&
        tabs.some(({ label }) => label === selectedTab)
      )
        setActiveTabIndex(tabs.findIndex(({ label }) => label === selectedTab));
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedTab, dispatch, tabs]);

    const onChange = (_, value) => {
      setActiveTabIndex(value);
    };

    const onClick = () =>
      disabled &&
      dispatch(
        addNotification({
          message: COLLECTION_TYPE_CHANGE_ON_EDIT_WARNING,
          options: { variant: "info" },
        })
      );

    return (
      <SectionMenuProvider value={activeTabIndex}>
        <Box className={styles.sectionMenu}>
          <HeaderTabs
            disabled={disabled}
            tabs={tabs}
            value={activeTabIndex}
            search={""}
            onChange={onChange}
            onClick={onClick}
          />
          <Box className={styles.listsContainer}>{children}</Box>
        </Box>
      </SectionMenuProvider>
    );
  }
);
